import _ from 'lodash'
import { getValueForMode, toUnits } from './toUnits'

export const makeGridTemplate = (component, componentStyles, mode, uid, columns, rows, target, isRepeatCol = false) => {
  let template = []
  let count = target === 'row' ? rows : columns
  _.times(count, (n) => {
    let valNum = getValueForMode(componentStyles, mode, [], [`${target}${n}`], '1')
    let valUnits = getValueForMode(componentStyles, mode, [], [`${target}${n}Unit`], 'fr')
    if (target !== 'row') {
      valNum = getValueForMode(componentStyles, mode, [], [`${target}${n}`], '1', '1')
      valUnits = getValueForMode(componentStyles, mode, [], [`${target}${n}Unit`], 'fr', 'fr')
    }
    template.push({ valNum, valUnits })
  })
  if (target === 'row' && (mode === 'xs' || mode === 'ss' || mode === 'sm')) {
    const frIndex = _.findIndex(template, ({ valUnits }) => valUnits === 'fr')
    if (frIndex === -1) {
      return _.map(template, ({ valNum, valUnits }) => `${toUnits(valNum, valUnits)}`).join(' ')
    } else {
      return _.map(template, ({ valNum, valUnits }) => `minmax(auto,${toUnits(valNum, valUnits)})`).join(' ')
    }
  } else {
    const frIndex = _.findIndex(template, ({ valUnits }) => valUnits === 'fr')
    if (frIndex === -1 && target !== 'row' && !isRepeatCol) {
      return _.map(template, ({ valNum, valUnits }) => `minmax(auto, ${toUnits(valNum, valUnits)})`).join(' ')
    } else {
      return _.map(template, ({ valNum, valUnits }) => `${toUnits(valNum, valUnits)}`).join(' ')
    }
  }
}
